/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Route } from 'react-router';
import { NotFoundPage, RequireAuthExternal } from 'sarsaparilla';

import StoryGallery from '../src/containers/StoryGallery';
import Story from '../src/containers/Story';

import routesArray from './routesArray';

const Components = {
    StoryGallery,
    Story,
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        if (route.requireAuth) {
            return (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        <RequireAuthExternal>
                            <Component />
                        </RequireAuthExternal>
                    }
                />
            );
        }
        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    routeComponents.push(<Route key="not-found" path="*" element={<NotFoundPage />} />);

    return routeComponents;
}
